//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { QueryRenderer, ReadyState } from "react-relay";
// fast-crawl-loader imports
import { IRendererProps } from "./fast-crawl-loaderTypes";
import { FastCrawlLoader } from "./FastCrawlLoader";
import { queries } from "./FastCrawlLoaderRenderer.gql";
// other internals
import { getFastCrawlFlowState } from "#webapp/src/state/onboarding";
import { getCurrentOrg } from "#webapp/src/util/org.util";
import { handleReadyStateError } from "#webapp/src/util/relay.util";

//////////////////
// COMPONENT
//////////////////
export class FastCrawlLoaderRenderer extends React.PureComponent<IRendererProps> {
  public render() {
    return (
      <QueryRenderer
        environment={this.props.environment}
        query={queries}
        variables={{}}
        render={(readyState: ReadyState) => {
          const viewer = readyState.props && readyState.props.viewer;
          const org = getCurrentOrg(viewer);
          const fastCrawlState = org && getFastCrawlFlowState(org);

          if (readyState.error) {
            handleReadyStateError(readyState.error, "Error rendering fast crawl loader");

            return <span />;
          } else if (!org || !fastCrawlState) {
            return <span />;
          }

          return <FastCrawlLoader flowState={fastCrawlState} />;
        }}
      />
    );
  }
}
